import { render } from "./ForgetPasswordView.vue?vue&type=template&id=2c55201b"
import script from "./ForgetPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__